
import { Union, Record } from "../../../fable_modules/fable-library-js.5.3.0/Types.js";
import { ChallengeResponse_$reflection } from "../../Shared.js";
import { union_type, record_type } from "../../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { HtmlHelper_createElement } from "../../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { textColor_textNeutral900, backgroundColor_bgSurface, space_spaceY4, textColor_textNeutral500, dark, backgroundColor_bgNeutral100, textColor_textNeutral700, space_spaceY1, tw } from "../../TailwindExtensions.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.5.3.0/List.js";
import { fontWeight_fontSemibold, fontSize_textLg, padding_p6, boxShadow_shadow, borderRadius_roundedLg, borderRadius_roundedMd, padding_px3, padding_py2, fontWeight_fontMedium, fontSize_textSm, gap_gap$002D1, alignItems_itemsCenter, display_flex } from "../../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { createElement } from "react";
import { IconWeight, IconSize, IconName, icon } from "../../Icons.js";
import { singleton as singleton_1, append, delay, toList } from "../../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { map, defaultArg } from "../../../fable_modules/fable-library-js.5.3.0/Option.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.5.3.0/String.js";
import { toString } from "../../../fable_modules/fable-library-js.5.3.0/Date.js";
import { toUniversalTime } from "../../../fable_modules/fable-library-js.5.3.0/DateOffset.js";
import { formatTimeAmPm } from "../TimeHelpers.js";
import { TimeOfDayModule_toStringFormatted } from "../../BaseTypes.js";

export class LockedProps extends Record {
    constructor(Challenge) {
        super();
        this.Challenge = Challenge;
    }
}

export function LockedProps_$reflection() {
    return record_type("Shared.Hero.ChallengeDetailsSidebar.LockedProps", [], LockedProps, () => [["Challenge", ChallengeResponse_$reflection()]]);
}

export class Mode extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["Locked"];
    }
}

export function Mode_$reflection() {
    return union_type("Shared.Hero.ChallengeDetailsSidebar.Mode", [], Mode, () => [[["Item", LockedProps_$reflection()]]]);
}

function lockedRow(label, value) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton(space_spaceY1))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap$002D1, fontSize_textSm, fontWeight_fontMedium, textColor_textNeutral700]))], ["children", [createElement(icon, {
        name: new IconName(33, []),
        size: new IconSize(0, []),
        weight: new IconWeight(1, []),
    }), HtmlHelper_createElement("span", singleton(["children", singleton(label)]))]]])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([padding_py2, padding_px3, backgroundColor_bgNeutral100, dark("bg-neutral-800"), borderRadius_roundedMd, textColor_textNeutral500, fontSize_textSm]))], ["children", singleton(value)]]))]]]));
}

function renderLocked(p) {
    const ch = p.Challenge;
    const isGoalFloorEnforced = (ch.Status === "pledged") ? true : (ch.Status === "active");
    return HtmlHelper_createElement("div", ofArray([["className", tw(singleton(space_spaceY4))], ["children", toList(delay(() => append(singleton_1(lockedRow("Title", ch.Title)), delay(() => append(singleton_1(lockedRow("Description", defaultArg(ch.Description, "(none)"))), delay(() => append(singleton_1(lockedRow("Activity", ch.Theme)), delay(() => append(singleton_1(lockedRow("Unit", ch.Unit)), delay(() => append(singleton_1(lockedRow("Duration", toText(printf("%d days"))(ch.Duration))), delay(() => {
        let hint;
        return append(isGoalFloorEnforced ? ((hint = ((ch.MinAllowedGoal == null) ? "see hero" : "see hero; can be lowered only to the minimum goal"), singleton_1(lockedRow("Target Amount", toText(printf("%.0f %s (%s)"))(ch.TargetAmount)(ch.Unit)(hint))))) : singleton_1(lockedRow("Target Amount", toText(printf("%.0f %s"))(ch.TargetAmount)(ch.Unit))), delay(() => {
            let arg_6, arg_7;
            return append(singleton_1(lockedRow("Start Date", (arg_6 = toString(toUniversalTime(ch.StartDate), "MMMM d, yyyy"), (arg_7 = formatTimeAmPm(toString(toUniversalTime(ch.StartDate), "HH:mm")), toText(printf("%s at %s"))(arg_6)(arg_7))))), delay(() => append(singleton_1(lockedRow("Reminder Time", defaultArg(map((r) => formatTimeAmPm(TimeOfDayModule_toStringFormatted(r)), ch.ReminderTimeOfDay), "(not set)"))), delay(() => singleton_1(lockedRow("Charity", ch.Charity.Name))))));
        }));
    }))))))))))))]]));
}

/**
 * Render the sidebar panel. The caller is responsible for rendering any
 * abandon dialog/trigger after this component (see ChallengeEditView).
 */
export function view(mode) {
    return HtmlHelper_createElement("aside", ofArray([["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadow, padding_p6, space_spaceY4]))], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontSemibold, textColor_textNeutral900]))], ["children", singleton("Challenge Details")]]))), delay(() => singleton_1(renderLocked(mode.fields[0]))))))]]));
}

//# sourceMappingURL=ChallengeDetailsSidebar.js.map
